import ScheduleView from './ScheduleView';

export default ScheduleView;
